//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    snapshotTable: Object
  }
}

